<template>

    <form ref="estagioavaliacao-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">
            <div class="form-group col-md-8">
                <label for="nome">Nome</label>
                <input type="text" class="form-control" name="nome" maxlength="100" placeholder="Nome" v-model="model.nome" required />
            </div>
            <div class="form-group col-md-4">
                <label for="unidade">Unidade</label>
                <input type="text" class="form-control" name="unidade" maxlength="20" placeholder="Unidade" v-model="model.unidade" />
            </div>
            <div class="form-group col-md-12">
                <label for="nomeTraduzido">Nome Traduzido</label>
                <input type="text" class="form-control" maxlength="150" name="nome" placeholder="Nome Traduzido" v-model="model.nomeTraduzido" required />
            </div>
            <div class="form-group col-md-4">
                <label for="tipoAvaliacaoId">Tipo de Avaliação</label>
                <select v-select="{ dataitem: 'TipoAvaliacao', default: 'Selecione' }" v-model="model.tipoAvaliacaoId" class="form-control" name="tipoAvaliacaoId" required></select>
            </div>
            <div class="form-group col-md-4">
                <label for="ordem">Ordem</label>
                <input type="number" class="form-control" min="0" name="ordem" placeholder="Ordem" v-model="model.ordem" required />
            </div>
            <div class="form-group col-md-4">
                <label for="pontuacao">Pontuação</label>
                <input type="text" class="form-control" name="pontuacao" placeholder="Pontuacao" v-model="model.pontuacao" required />
            </div>
            <div class="form-group col-md-4">
                <label for="pontuacao">External ID</label>
                <input type="number" class="form-control" name="externalId" placeholder="External ID" v-model="model.externalId" required />
            </div>
            <div class="form-group col-md-4">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="ignoraPontuacaoPadrao" class="custom-control-input" v-model="model.ignoraPontuacaoPadrao">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Lança nota de 0 a 10?</span>
                </label>
            </div>
            <div class="form-group col-md-4">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="meioCurso" class="custom-control-input" v-model="model.meioCurso">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Meio de Curso?</span>
                </label>
            </div>
            <div class="form-group col-md-4">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="salaAula" class="custom-control-input" v-model="model.salaAula">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Sala de Aula?</span>
                </label>
            </div>
            <div class="form-group col-md-4">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="excluido" class="custom-control-input" v-model="model.excluido">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Excluído?</span>
                </label>
            </div>
        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "estagioavaliacao-form-edit",
        mixins: [base],
        props: { id: Number },
        data: () => ({

            model: {},

            form: "estagioavaliacao-form-edit",

            resources: {
                edit: 'estagioavaliacao',
            },

        }),

        methods: {

            executeEdit: function (model) {

                if (this.formValidate() == false) return;

                new Api(this.resources.edit).put(model).then(data => {
                    this.defaultSuccessResult("Edição realizada com sucesso");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },

        mounted() {
            new Api(this.resources.edit).get({ estagioAvaliacaoId: this.id }).then(data => {
                if (data.data) this.model = data.data;
                else if (!data.dataList) this.model = {};
                else if (data.dataList.length == 1) this.model = data.dataList[0];
                else this.model = {};
            }, err => {
                this.defaultErrorResult(err);
            })
        }
    };
</script>